
import { Component } from "vue-property-decorator";
import AeDatePicker from "@/components/common/DatePicker.vue";
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import {dateFormat} from "@vuejs-community/vue-filter-date-format";
import {dateToIndexerValue} from "@/app/helpers/date.helper";
import {ValidationError} from "@/app/dynamic-components/forms/form-validations/form-validator.base";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

type DatePickerMetaData = {
  disabled?: boolean;
  restrictions: string
  defaultValue: string
};

@Component({
  methods: {dateFormat},
  components: {DynamicComponentConfigManager, AeDatePicker },
})
export default class DatePickerBase extends BaseDynamicComponent<DatePickerMetaData> {
  userLanguage = "";

  getDateDisplay(){
    if(!this.value) return '-'
    const d = new Date(this.value);
    if(Number.isNaN(d.getTime())) return 'NaN'
    return d.getDate().toString().padStart(2,'0') + '/' + (d.getMonth() + 1).toString().padStart(2,'0') + '/' + d.getFullYear().toString().padStart(4,'0');
  }

  mounted() {
    this.userLanguage = this.$store.state.user.language;
  }
  onDatePickerContentChanged(newValue: string) {
    this.setValueView(newValue);
  }

  getDateRestriction(restrictions: string | null){
    if(!restrictions || !restrictions.startsWith('date:{')) return null;
    return this.entry.root?.resolvePlaceholders(restrictions);
    //return false;
  }


  public async fillIndexerValue(indexerField: string, indexerSelector): Promise<any> {
    return dateToIndexerValue(indexerField, this.value);
  }


  public getDefaultValue(): any {
    if(this.entry?.metadata?.defaultValue && this.entry.root){
      let d = this.entry.root?.resolvePlaceholders(this.entry.metadata.defaultValue);
      d = this.entry.root.externalContext.resolveFieldValue(d);
      const x = new Date(d);
      if(isNaN(x.getTime())) return null;
      return x.toISOString();
    }
    return null;
  }
}
